import React, { Component } from 'react';
import { number, func, string } from 'prop-types';
import Radium from 'radium';
import { UTLabel, UTTouchableWithoutFeedback } from '@widergy/energy-ui';

import styles from './styles';

class SquaredButton extends Component {
  render() {
    return (
      <UTTouchableWithoutFeedback
        onClick={this.props.onClick}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <div style={styles[`square${this.props.index}`]}>
          <UTLabel extrabold xlarge white>
            {`0${this.props.index + 1}`}
          </UTLabel>
          <div style={[styles[`content${this.props.index}`], styles.content]}>
            <div style={styles.iconContainer}>
              <img src={this.props.icon} style={styles.icon} alt="" />
            </div>
            <UTLabel white small bold style={styles.category}>
              {this.props.title}
            </UTLabel>
          </div>
        </div>
      </UTTouchableWithoutFeedback>
    );
  }
}

SquaredButton.propTypes = {
  index: number.isRequired,
  onClick: func.isRequired,
  title: string,
  icon: string.isRequired
};

SquaredButton.defaultProps = {
  title: ''
};

export default Radium(SquaredButton);
